'use strict';

var tslib_es6 = require('../../_virtual/tslib.es6-c0cde917.js');
var React = require('react');
var ReactDOM = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Portal = (_a) => {
    var { onOverlayClick, overlayClassName, children } = _a, portalAttributes = tslib_es6.__rest(_a, ["onOverlayClick", "overlayClassName", "children"]);
    const [container, setContainer] = React.useState(undefined);
    React.useEffect(() => {
        if (typeof document !== 'undefined' && !container) {
            setContainer(() => {
                const element = document.createElement('div');
                // you can use this variable to create a responsive full width portal overlay -> width: calc(100vw - var(--wds-modal-scrollbar-width));
                element.style.setProperty('--wds-modal-scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
                Object.entries(portalAttributes).forEach(([key, value]) => {
                    element.setAttribute(key, value);
                });
                if (onOverlayClick) {
                    element.addEventListener('click', (e) => {
                        const target = e.target;
                        if (target === element) {
                            onOverlayClick === null || onOverlayClick === void 0 ? void 0 : onOverlayClick(e);
                        }
                    });
                }
                if (overlayClassName) {
                    element.className = overlayClassName;
                }
                return element;
            });
        }
    }, []);
    React.useEffect(() => {
        if (container) {
            document.body.appendChild(container);
        }
        return () => {
            if (container) {
                document.body.removeChild(container);
            }
        };
    }, [container]);
    return container ? React__default["default"].createElement(React__default["default"].Fragment, null, ReactDOM.createPortal(children, container)) : React__default["default"].createElement(React__default["default"].Fragment, null);
};

module.exports = Portal;
